<template>
    <div class="row">
        <div class="input-field col s12 m12 l12 xl12">
            <label for="nome" class="active">Nome:</label>
            <input
                type="text"
                :disabled="disabled"
                name="nome"
                id="nome"
                v-model="itemData.nome"
            />
        </div>
        <div class="input-field col s12 m12 l12 xl12">
            <select class="browser-default" v-model="itemData.nota">
                <option
                    v-for="(nota, index) in notasValidas"
                    :key="index"
                    :value="nota"
                >
                    {{ nota }}
                </option>
            </select>
        </div>
        <div class="input-field col s1 m1 l1 xl1">
            <a class="waves-effect waves-light btn-small" @click="addItem()"
                ><i class="material-icons">add</i></a
            >
        </div>
    </div>
</template>
<script>
export default {
    name: "AvaliacaoOpcaoOutros",
    props: {
        item: {
            required: true,
            type: Object
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            itemData: {
                nota_min: this.item.nota_min,
                nota_max: this.item.nota_max,
                nota_var: this.item.nota_var,
                aval_subgrupo_id: this.item.aval_subgrupo_id,
                nome: this.item.nome,
                nota: 0,
                peso: this.item.peso
            },
            notasValidas: []
        };
    },
    methods: {
        verifyNota() {
            if (
                !this.itemData.nota ||
                this.itemData.nota == undefined ||
                this.itemData.nota == NaN ||
                this.itemData.nota == null ||
                this.itemData.nota == ""
            ) {
                showMsg("Por favor, selecione uma nota!");
                return false;
            }
            return true;
        },
        addItem() {
            this.verifyNota() ? this.$emit("add-item", this.itemData) : false;
        },
        criaSelect() {
            let notaMaxima = Number(this.itemData.nota_max);
            let notaMinima = Number(this.itemData.nota_min);
            let variacao = Number(this.itemData.nota_var);
            for (let i = notaMinima; i <= notaMaxima; i = i + variacao) {
                this.notasValidas.push(i.toFixed(1));
            }
        }
    },
    mounted() {
        this.criaSelect();
    }
};
</script>
